import { useMutation } from '@tanstack/react-query';
import { unregisterNotificationDevice } from '../services/notifications';

/** POST /admin/notifications/unregister-device */
export const useUnregisterNotificationDeviceMutation = (options = {}) => {
  const { onSuccess, onError, ...restOptions } = options;

  return useMutation({
    mutationFn: async (payload) => {
      const result = await unregisterNotificationDevice(payload);
      if (!result.success) {
        throw new Error(result.message || 'Failed to unregister device for notifications');
      }
      return result;
    },
    onSuccess: async (data, variables, context) => {
      await onSuccess?.(data, variables, context);
    },
    onError: (error, variables, context) => {
      onError?.(error, variables, context);
    },
    ...restOptions,
  });
};
